import {
  CommonsMParticleListing,
  CommonsMParticleOrderBundles,
} from '../rql';

type MPEvent<T extends MParticleEventName, K extends keyof AllEventProps> =
  {
    eventName: T;
    eventType?: EventType;
    listing?: CommonsMParticleListing.Listings;
    experiments?: string;
    componentName?: string;
  } &
  { [P in K]: AllEventProps[P] };

export enum MParticleEventName {
  AddToCart = 'Add to cart',
  Purchase = 'Purchase',
  ProductAction = 'Product Action',
  SiteSearch = 'Searched Site',
  ClickedOfferButton = 'Clicked Offer Button',
  SubmittedOffer = 'Submitted Offer',
  ViewedSignupSignin = 'Viewed User Sign Up/In',
  AddedFollow = 'Added Follow',
  RemovedFollow = 'Removed Follow',
  ClickedCSPCard = 'Clicked CSP Card',
  ViewedSimilarCspsRow = 'Viewed Similar Csps Row',
  ClickedListingCard = 'Clicked Listing Card',
  AddToWishlist = 'Added to Watch List',
  RemoveFromWishlist = 'Removed from Watch List',
  LoggedOutWatch = 'Logged Out Watch',
  ListingImpression = 'Listing Impression',
  ComponentView = 'Component View',
  ProductViewAction = 'Product View Action',
  GenericPageView = 'Generic Page View',
  NavBarInteraction = 'Navbar Interaction',
  ViewedI2CombinedShipping = 'Viewed I2 Combined Shipping',
  ViewedBumpSlider = 'Viewed Bump Slider',
  AdjustBumpRate = 'Adjust Bump Rate',
  ClickedSearchSuggestion = 'Clicked Search Suggestion',
  ViewedBumpDisplay = 'Viewed Bump Display',
  ViewedCSPComponent = 'Viewed CSP Component',
  ViewedFeaturedListing = 'Viewed Featured Listing',
  ClickedCombineAndSaveViewAll = 'Clicked Combine and Save View All',
  CmsExperimentQualifyingEvent = 'CMS Experiment Qualifying Event',
  ClickedToggledContent = 'Clicked Toggled Content',
  ClickedPagination = 'Clicked Pagination',
  ClickedSellCard = 'Clicked Sell Card',
  ViewedRollupListingCard = 'Viewed Rollup Listing Card',
  ClickedCompareOtherSellersLink = 'Clicked Compare Other Sellers Link',
  OpenedPrivacySettingsModal = 'Opened Privacy Settings Modal',
  ClickedComponent = 'Clicked Component',
  ClickedSearchFilter = 'Clicked Search Filter',
  ClickedClearSiteSearch = 'Clicked Clear Site Search',
  ClickedSellYoursOnCsp = 'Clicked Sell Yours on CSP',
  ClickedSearchInput = 'Clicked Search Input',
  ClickedSearchFilterChip = 'Clicked Search Filter Chip',
  ClickedRemoveFromCart = 'Clicked Remove From Cart',
  RemoveFromCart = 'Remove From Cart',
  UnmatchedGearCollectionItem = 'Unmatched Gear Collection Item',
  GearCollectionStartOver = 'Gear Collection Start Over',
  ViewedGearCollectionForm = 'Viewed Gear Collection Form',
  ViewedGearCollectionItemShowPage = 'View Gear Collection Item Show Page',
  ClickedGearCollectionItemListForSale = 'Clicked Gear Collection Item List For Sale',
  ApplePayOffered = 'Apple Pay Offered',
  ClickedApplePayButton = 'Clicked Apple Pay Button',
  ClickedLoggedOutApplePayButton = 'Clicked Logged Out Apple Pay Button',
  ClickedAppleSigninButton = 'Clicked Apple Signin Button',
  AdImpression = 'Ad Impression',
  AdClick = 'Ad Click',
  AdObserved = 'Ad Observed',
  ClickedRSLCalloutAction = 'Clicked RSL Callout Action',
  ClickedKeepShoppingLink = 'Clicked Keep Shopping Link',
  ViewedKeepShoppingLink = 'Viewed Keep Shopping Link',
  ClickedReverbShippingGuideInsideShippingPrompt = 'Clicked Reverb Shipping Guide Inside Shipping Prompt',
  ClickedReverbShippingBoxTitleInsideShippingPrompt = 'Clicked Reverb Shipping Box Title Inside Shipping Prompt',
  ClickedReverbShippingBoxImageInsideShippingPrompt = 'Clicked Reverb Shipping Box Image Inside Shipping Prompt',
  DismissedShippingPromptModal = 'Dismissed Shipping Prompt Modal',
  ViewedProductFamilyPage = 'Viewed Product Family Page',
  ViewedPriceGuideEstimatedValue = 'Viewed Price Guide Estimated Value',
  ClickedI2ShopPoliciesModal = 'Clicked Item2 Shop Policies Modal',
  ChangedGlobalSubscriptionStatus = 'Changed Global Subscription Status',
  ChangedSubscriptionGroupStatus = 'Changed Subscription Group Status',
  TriggeredOptInEmail = 'Triggered Opt-in Email',
  ClickedSecondaryNagBannerCalloutAction = 'Clicked Secondary Nag Banner Callout Action',
  DismissedSecondaryNagBanner = 'Dismissed Secondary Nag Banner',
  SiteBanner = 'Clicked Site Banner',
  ClickedMosaicTile = 'Clicked Mosaic Tile',
  PlaidLink = 'Plaid Link',
  SelectedPayoutMethod = 'Selected Payout Method',
  ClickedChangeBankAccountLink = 'Clicked Change Bank Account Link',
  ClickedCancelBankAccountChangesLink = 'Clicked Cancel Bank Account Changes Link',
  ViewedPaymentSettings = 'Viewed Payment Settings',
  MarketplaceGridAdQE = 'Marketplace_grid_ad qualifying event',
  ClickedMarketingCallout = 'Clicked Marketing Callout',
  EndedListingPageAdView = 'Ended Listing Page Ad View',
  ViewedListingAcceptedPaymentMethods = 'Viewed Listing Accepted Payment Methods',
  ClickedSubqueryRowSeeMoreLink = 'Clicked Subquery Row See More Link',
  UpdatedInternationalSettings = 'Updated International Settings',
  InternationalSettingsReverted = 'International Settings Reverted',
  ViewedInternationalSettingsConfirmation = 'Viewed International Settings Confirmation',
  ClickedListViewToggle = 'Clicked List View Toggle',
  ClickedLinkList = 'Clicked Link List',
  ClickedCategory = 'Clicked Category',
  ClickedSellYoursV4 = 'Clicked Sell Yours V4',
  ClickedUserNotification = 'Clicked User Notification',
  CartItemSignalsViewed = 'Viewed Cart-Item Signals',
  ClickedBuyItNowButton = 'Clicked Buy It Now Button',
  ClickedBuyItNowPaymentMethod = 'Clicked Buy It Now Payment Method',
  ClickedTrait = 'Clicked Trait',
  EligibleForEmailPopUp = 'Eligible for Email Pop Up',
  DisplayedEmailPopUp = 'Displayed Email Pop Up',
  ViewedItemEndedHeaderSimilarListings = 'Viewed Item Ended Header Similar Listings',
  ViewedItemFooterSimilarListings = 'Viewed Item Footer Similar Listings',
  ViewedItemPaidHeaderSimilarListings = 'Viewed Item Paid Header Similar Listings',
  AdaChatButtonClicked = 'Ada Chat Button Clicked',
  AdaChatOpenSuccess = 'Ada Chat Open Success',
  AdaChatAnswerServed = 'Ada Chat Answer Served',
  AdaChatConversationManuallyEnded = 'Ada Chat Conversation Manually Ended',
  ClickedRecommendedShopCard = 'Clicked Recommended Shop Card',
  ClickedAppCalloutButton = 'Clicked App Callout Button',
  ViewedTopProductsPage = 'Viewed Top Products Page',
  ViewedRecentlyViewedCspsRow = 'Viewed Recently Viewed CSPs Row',
  ClickedHomepageCategorySearchButton = 'Clicked Homepage Category Search Button',
  ClickedHomepageSearchSellGearLink = 'Clicked Homepage Search Sell Gear Link',
  RedirectedToCSPFromEndedListing = 'Redirected To CSP From Ended Listing',
  ViewedEndedListingToast = 'Viewed Ended Listing Toast',
  DismissedEndedListingToast = 'Dismissed Ended Listing Toast',
  ViewedEndedListing = 'Viewed Ended Listing',
  ClickedGetPriceEstimateButtonInsidePriceGuideToolCard = 'Clicked Get Price Estimate Button Inside Price Guide Tool Card',
  ClickedBackButtonToPriceGuideToolIndex = 'Clicked Back Button To Price Guide Tool Index',
  ClickedPriceGearButtonInPriceGuideTool = 'Clicked Price Gear Button in Price Guide Tool',
  ClickedSellYoursButtonFromPriceGuideTool = 'Clicked Sell Yours Button From Price Guide Tool',
  ClickedViewLiveListingsButtonFromPriceGuideTool = 'Clicked View Live Listings Button From Price Guide Tool',
  ClickedAddToGearCollectionFromPriceGuideTool = 'Clicked Add to Gear Collection From Price Guide Tool',
  ClickedTrendingSearchesPill = 'Clicked Trending Searches Pill in Site Search',
  ClickedCspTilesCta = 'Clicked CSP Tiles CTA',
  ClickedPriceGuideToolTransactionGraphDateRangeButton = 'Clicked Price Guide Tool Transaction Graph Date Range Button',
  ClickedHowToDateYourGearFromPriceGuideTool = 'Clicked How To Date Your Gear From Price Guide Tool',
  ClickedHowGearChangesOverTimeFromPriceGuideTool = 'Clicked How Gear Changes Over Time From Price Guide Tool',
  ClickedVintageGuitarFAQFromPriceGuideTool = 'Clicked Vintage Guitar FAQ From Price Guide Tool',
  ClickedBackButtonToPriceGuideToolIndexWhenNoEstimate = 'Clicked Back Button to Price Guide Tool Index when No Estimate',
  ClickedViewLiveListingsFromPriceGuideToolShowWhenNoEstimate = 'Clicked View Live Listings from Price Guide Tool Show when NoEstimate',
  SellFormInteraction = 'Sell Form Interaction',
}

export enum MParticlePageName {
  Cart = 'Checkout - Cart',
  Shipping = 'Checkout - Shipping',
  Payment = 'Checkout - Payment',
  ReviewOrder = 'Checkout - Review Order',
  ChangeShipping = 'Checkout - Change Shipping',
  ChangePayment = 'Checkout - Change Payment',
  SellSearch = 'Sell Flow - Search',
  SellForm = 'Sell Flow - Form',
  Homepage = 'Homepage',
  Marketplace = 'Marketplace',
  Brand = 'Marketplace - Brand',
  Shop = 'Marketplace - Shop',
  Handpicked = 'Marketplace - Handpicked',
  Sale = 'Marketplace - Sale',
  CSP = 'CSP',
  WatchList = 'My - Watch List',
  Feed = 'My - Feed',
  RecentlyViewed = 'My - Recently Viewed',
  CMS = 'CMS',
  Page = 'Static Page',
  NewsHomepage = 'News - Homepage',
  NewsArticle = 'News - Article',
  Holiday = 'Holiday Sale',
  MobileBump = 'Mobile Bump',
  CreateShippingProfileForm = 'New Shipping Profile Form',
  SellerDashboard = 'Seller Dashboard',
  RedeemPromoCode = 'Redeem Promotional Code',
  RedeemGiftCard = 'Redeem Gift Card',
  RecommendedListings = 'Recommended Listings',
  EmailPreferences = 'Email Preferences',
  GetPaid = 'Get Paid',
  ShopPolicies = 'Shop Policies',
  ShopOnboarding = 'Shop Onboarding',
  ShopTaxId = 'Shop Tax ID',
  SimilarListings = 'Similar Listings',
}

// Custom attributes on an mparticle product
export interface ListingProps {
  condition: string;
  conditionName: string;
  subcategories: string;
  listingId: string;
  listingType: string;
  state: string;
  cspSlug: string;
  cspId: string;
  bumpEligible: boolean;
  freeExpeditedShipping?: boolean;
  freeShipping?: boolean;
  localPickupOnly?: boolean;
  shopId: string;
  inventory: number;
  shownAsBumped?: boolean;
  localPickup?: boolean;
  returnWindowDays: number;
  itemLocation?: string;
  daysSincePublished?: number;
}

interface CustomEventListingBaseProps {
  brand: string;
  category: string;
  couponCode: string;
  listingTitle: string;
  price: string;
}

export type CustomEventListingProps = CustomEventListingBaseProps & ListingProps;

interface AllEventProps {
  // MParticle enum for custom events https://docs.mparticle.com/developers/sdk/web/event-tracking/#custom-event-type
  eventType: EventType;
  pageName: MParticlePageName;
  experiments: string;

  // General URL props
  referringUrl: string;
  currentUrl: string;
  requestId: string;
  cookieId: string;
  reverbSessionId: string;
  targetUrl: string;

  // PageView/ecomm event properties
  quantity: number;
  itemCount: number; // Number of unique items in cart/checkout
  sellerCount: number; // Number of unique sellers in cart/checkout
  totalPrice: string;
  totalShippingRate: string;
  paymentMethod: string;
  paymentMethodsAvailable: string;
  'negotiatedOrder?': boolean;
  prefilled: boolean;

  // entity IDs
  listingId: string | number;
  listingIds: (string | number)[];
  cpId: string | number;
  cspId: string | number;
  cspIds: string; // pipe-delimited
  gciId: string | number;
  brand: string; // brand slug, named 'brand' for consistency with ecommerce events
  category: string; // category slug, named 'category' for consistency with ecommerce events
  cspSlug: string;
  pageSlug: string;
  curatedSetSlug: string;
  shopSlug: string;
  followId: string;
  cmsPageSlug: string;
  articleSlug: string;
  productFamilySlug: string;
  bumpedListingIds: (string | number)[];
  freeShippingListingIds: (string | number)[];
  returnPolicyListingIds: (string | number)[];
  conditionSlug: string;

  // Component props
  componentName: string;
  displayStyle: string;
  entityId: string;
  entityType: string;
  shownAsBumped: boolean;

  // Adhoc props tacked onto ComponentView events for specific contexts
  shopCreatedYear: string;
  shopOrdersCount: number;
  freeShippingThresholdMet: boolean;
  collectionName: string;
  hasCategoryAffinities: boolean;
  recommendedShippingRateUsdCents: number;
  viewContext: string;
  viewedEstimatedValue: boolean;
  estimatedValueAvailable: boolean;
  dateRange: string;
  totalOrders: number;
  forNewListing: boolean;
  autodirected: boolean;
  hasCanonicalProductInGearCollection: boolean;

  // 'virtual' props that we need to transform client-side before sending to mparticle
  orderBundle: CommonsMParticleOrderBundles.OrderBundles;
  listing: CommonsMParticleListing.Listings;
  listings: CommonsMParticleListing.Listings[];

  offerAction: 'view' | 'submit';
  discountPercent: number; // whole number discount percentage (ex: 20)
  recommendedPriceDropPercent: number;
  firstTimeOfferer: boolean;
  combinedRateFree: boolean;
  suggestionCount: number;
  suggestionQuery: string;
  suggestionType: string;
  suggestionId: string;
  productFamilyRedirectEligible: boolean;
  position: number;
  interactionType: string;
  checkoutItemCount: number;
  productActionType: ProductActionType;
  cmsPageType: string;
  articleCategories: string;
  subcategories: string;
  followType: string;
  listingState: string;
  listingsCount: number;
  fallbackListingsCount: number;
  cspsCount: number;
  usedInventory: number;
  newInventory: number;
  totalInventory: number;
  query: string;
  querySuggestion: string;
  page: number;
  totalPages: number;
  productType: string;
  make: string;
  city: string;
  region: string;
  countryCode: string;
  matched: boolean;
  editingPersisted: boolean;
  listingSeedId: string;
  orderSeedId: string;
  hasOriginalListing: boolean;
  hideListingPhotos: boolean;
  hideListingDescription: boolean;
  hasDataServicesPriceEstimate: boolean;
  hasUserEstimate: boolean;
  gearCollectionItemId: string;
  tagsCount: number;
  promotionalToken: string;
  finishCount: number;
  sort: string;

  // bump props
  bumped: boolean;
  bumpEligible: boolean;
  newBumpRatePercent: number;
  startingBumpRatePercent: number;
  bumpRecommendationPercent: number;

  // Questionable events
  source: string;
  view: string;

  // facet props
  selected: boolean;
  parent: string;
  min: string;
  max: string;

  // proximity props
  distance: string;
  postalCode: string;

  applePayAvailableForDevice: boolean;

  // ads props
  adId: string;
  adUuid: string;
  adGroupUuid: string;
  adGroupName: string;
  adCampaignUuid: string;
  advertiserUuid: string;
  title: string;
  format: string;
  adZoneSlugs: string; // pipe-delimited

  // email preferences props
  globalSubscriptionState: string;
  subscriptionGroup: string;
  subscriptionGroupState: boolean;

  // site banner and homepage mosaic tile props
  isAd: boolean;
  isDefault: boolean;
  isListingDomesticToBuyer: boolean;
  isPlaid: boolean; // bank account settings props

  // homepage mosaic tile prop
  mosaicPosition: string;

  // plaid link event props
  plaidExitStatus: string;
  plaidErrorMessage: string;
  plaidLinkSessionId: string;
  plaidEventName: string;

  // payout method change event props
  payoutMethod: string;

  // international settings props
  newShippingRegionCode: string;
  newLocaleCode: string;
  newCurrency: string;
  oldShippingRegionCode: string;
  oldLocaleCode: string;
  oldCurrency: string;
  trait: string;

  // seller location listings rows props
  similarListingsCount: number;
  cmsListingsRowsCount: number;
  isFeaturedInCSPCollection: boolean;

  // ada chat props
  initialUrl: string;
  language: string;
  lastAnswerId: string;
  lastQuestionAsked: string;

  // Recommended Shop Cards
  shopId: string;
  shopCount: number;

  // Trending Searches
  trendingSearchesCount: number;
  recentSearchesCount: number;

  // Custom sell form interaction events
  interactionName: 'clickedSubwayTo' | 'updatedPhotos' | 'addedShippingRegion';
  sectionName: string;
  listingCreateFlow: boolean;
}

// Subset of properties we add to all events
export type CommonProperties = Pick<AllEventProps, 'referringUrl' | 'currentUrl' | 'requestId' | 'cookieId' | 'reverbSessionId' >;

/* ecommerce/builtin events */
export type PageViewEvent = { pageName: MParticlePageName } & Partial<AllEventProps>;

export type ProductActionEvent =
  MPEvent<MParticleEventName.ProductAction, 'listing' | 'productActionType'>;

export type ProductViewActionEvent =
  MPEvent<MParticleEventName.ProductViewAction, 'listing' | 'displayStyle' | 'experiments' >;

export type GenericPageViewEvent = { eventName: string } & Partial<AllEventProps>;

export type MparticleListingImpressionEvent =
  MPEvent<MParticleEventName.ListingImpression, 'listingIds' | 'listings' | 'shownAsBumped' | 'componentName'>;

export type MparticleClickedAddToCartEvent =
  MPEvent<MParticleEventName.AddToCart, 'listing' | 'productActionType' | 'position' | 'componentName' | 'source'>;
export type MparticleAddToWishlistEvent =
  MPEvent<MParticleEventName.AddToWishlist, 'listing' | 'productActionType' | 'position' | 'componentName' | 'source' | 'experiments' >;
export type MparticleRemoveFromWishlistEvent =
  MPEvent<MParticleEventName.RemoveFromWishlist, 'listing' | 'productActionType' | 'position' | 'componentName' | 'source' | 'experiments' >;
export type MparticleRemoveFromCartEvent =
  MPEvent<MParticleEventName.RemoveFromCart, 'listing' | 'productActionType' | 'position' | 'componentName' | 'source'>;

export type PurchaseEvent = MPEvent<MParticleEventName.Purchase, 'orderBundle'>;

export type SellFormInteraction = MPEvent<MParticleEventName.SellFormInteraction, 'interactionName' | 'sectionName' | 'listingCreateFlow'>;

export type ViewedCSPComponentEvent = MPEvent<
MParticleEventName.ViewedCSPComponent,
'cspIds'
| 'componentName'
| 'displayStyle'
| 'cspsCount'
>;

export type ClickedComponentEvent = MPEvent<
MParticleEventName.ClickedComponent,
'componentName'
| 'entityId'
| 'entityType'
| 'position'
| 'displayStyle'
| 'interactionType'
>;

export type ClickedShopPoliciesModalEvent = MPEvent<
MParticleEventName.ClickedI2ShopPoliciesModal,
'componentName'
| 'listingId'
>;

export type CmsExperimentQualifyingEvent = MPEvent<
MParticleEventName.CmsExperimentQualifyingEvent,
null
>;

export type MparticleClickedCSPCardEvent = MPEvent<
MParticleEventName.ClickedCSPCard,
'cspId'
| 'cspSlug'
| 'displayStyle'
| 'brand'
| 'category'
| 'position'
| 'subcategories'
| 'usedInventory'
| 'newInventory'
| 'totalInventory'
>;

export type ClickedListingCardEvent = MPEvent<
MParticleEventName.ClickedListingCard,
'listing'
| 'componentName'
| 'displayStyle'
| 'position'
| 'listingsCount'
| 'city'
| 'region'
| 'countryCode'
| 'isListingDomesticToBuyer'
| 'isFeaturedInCSPCollection'
>;

export type ClickedRecommendedShopCardEvent = MPEvent<
MParticleEventName.ClickedRecommendedShopCard,
'shopId'
| 'listingId'
| 'position'
| 'shopCount'
>;

export type ClickedToggledContent = MPEvent<
MParticleEventName.ClickedToggledContent,
'componentName'
| 'listing'
| 'experiments'
| 'interactionType'
>;

export type ClickedSearchFilter = MPEvent<
MParticleEventName.ClickedSearchFilter,
'componentName'
| 'displayStyle'
| 'selected'
| 'query'
| 'postalCode'
| 'distance'
>;

export type ClickedSearchFilterChip = MPEvent<
MParticleEventName.ClickedSearchFilterChip,
'displayStyle'
| 'parent'
| 'query'
>;

export type AdImpression = MPEvent<
MParticleEventName.AdImpression,
'componentName'
| 'adId'
| 'adUuid'
| 'adGroupUuid'
| 'adGroupName'
| 'adCampaignUuid'
| 'advertiserUuid'
| 'format'
| 'title'
| 'adZoneSlugs'
>;

export type AdClick = MPEvent<
MParticleEventName.AdClick,
'componentName'
| 'adId'
| 'adUuid'
| 'adGroupUuid'
| 'adGroupName'
| 'adCampaignUuid'
| 'advertiserUuid'
| 'format'
| 'title'
| 'adZoneSlugs'
>;

export type AdObserved = MPEvent<
MParticleEventName.AdObserved,
'componentName'
| 'adId'
| 'adUuid'
| 'adGroupUuid'
| 'adCampaignUuid'
| 'advertiserUuid'
| 'format'
| 'title'
| 'adZoneSlugs'
>;

export type ComponentView = MPEvent<
MParticleEventName.ComponentView,
'componentName'
| 'entityId'
| 'entityType'
| 'displayStyle'
| 'listingId'
| 'shopCreatedYear'
| 'shopOrdersCount'
| 'listingsCount'
| 'freeShippingThresholdMet'
| 'shopSlug'
| 'collectionName'
| 'hasCategoryAffinities'
| 'recommendedShippingRateUsdCents'
| 'viewContext'
>;

export type ViewedFeaturedListing = MPEvent<
MParticleEventName.ViewedFeaturedListing,
'componentName'
| 'cspId'
| 'category'
| 'subcategories'
| 'newInventory'
| 'usedInventory'
| 'listing'
| 'bumped'
>;

export type ViewedGearCollectionForm = MPEvent<
MParticleEventName.ViewedGearCollectionForm,
'matched'
| 'editingPersisted'
| 'listingSeedId'
| 'orderSeedId'
| 'gearCollectionItemId'
>;

export type ViewedGearCollectionItemShowPage = MPEvent<
MParticleEventName.ViewedGearCollectionItemShowPage,
'hasOriginalListing'
| 'hideListingPhotos'
| 'hideListingDescription'
| 'hasDataServicesPriceEstimate'
| 'hasUserEstimate'
| 'gearCollectionItemId'
| 'tagsCount'
>;

export type ViewedRollupListingCard = MPEvent<
MParticleEventName.ViewedRollupListingCard,
'bumped'
>;

export type AdjustBumpRateInteraction = MPEvent<
MParticleEventName.AdjustBumpRate,
'componentName'
| 'listing'
| 'newBumpRatePercent'
| 'startingBumpRatePercent'
| 'bumpRecommendationPercent'
>;

export type ViewedBumpSliderInteraction = MPEvent<
MParticleEventName.ViewedBumpSlider,
'componentName'
| 'listing'
| 'startingBumpRatePercent'
>;

export type ViewedBumpDisplayInteraction = MPEvent<
MParticleEventName.ViewedBumpSlider,
'componentName'
| 'listing'
| 'startingBumpRatePercent'
>;

export type ClickedCombineAndSaveViewAll = MPEvent<
MParticleEventName.ClickedCombineAndSaveViewAll,
'shopSlug' | 'listingId'
>;

export type ClickedPagination = MPEvent<
MParticleEventName.ClickedPagination,
'componentName'
| 'position'
>;

export type ClickedCompareOtherSellersLink = MPEvent<
MParticleEventName.ClickedCompareOtherSellersLink,
'componentName'
>;

export type ClickedClearSiteSearch = MPEvent<
MParticleEventName.ClickedClearSiteSearch,
'query'
>;

export type ClickedSellYoursOnCsp = MPEvent<
MParticleEventName.ClickedSellYoursOnCsp,
'cspId'
>;

export type ClickedGearCollectionItemListForSale = MPEvent<
MParticleEventName.ClickedGearCollectionItemListForSale,
'gciId'
>;

export type ChangedSubscriptionGroupStatus = MPEvent<
MParticleEventName.ChangedSubscriptionGroupStatus,
'subscriptionGroup'
| 'subscriptionGroupState'
>;

export type ChangedGlobalSubscriptionStatus = MPEvent<
MParticleEventName.ChangedGlobalSubscriptionStatus,
'globalSubscriptionState'
>;

export type TriggeredOptInEmail = MPEvent<
MParticleEventName.TriggeredOptInEmail,
null
>;

export type PlaidLinkEvent = MPEvent<
MParticleEventName.PlaidLink,
'plaidExitStatus'
| 'plaidErrorMessage'
| 'plaidLinkSessionId'
| 'plaidEventName'
>;

export type SelectedPayoutMethod = MPEvent<
MParticleEventName.SelectedPayoutMethod,
'payoutMethod'
>;

export type ViewedPaymentSettings = MPEvent<
MParticleEventName.ViewedPaymentSettings,
'isPlaid'
>;

export type ViewedListingAcceptedPaymentMethods = MPEvent<
MParticleEventName.ViewedListingAcceptedPaymentMethods,
'paymentMethodsAvailable'
>;

export type UpdatedInternationalSettings = MPEvent<
MParticleEventName.UpdatedInternationalSettings,
'newShippingRegionCode'
| 'newLocaleCode'
| 'newCurrency'
| 'oldShippingRegionCode'
| 'oldLocaleCode'
| 'oldCurrency'
>;

export type ClickedLinkList = MPEvent<
MParticleEventName.ClickedLinkList,
'displayStyle'
| 'targetUrl'
>;

export type ClickedCategory = MPEvent<
MParticleEventName.ClickedCategory,
'displayStyle'
| 'category'
| 'subcategories'
| 'targetUrl'
>;

export type ClickedTrait = MPEvent<
MParticleEventName.ClickedCategory,
'trait'
| 'targetUrl'
>;

export type MParticleAdaChatEnded = MPEvent<
MParticleEventName.AdaChatConversationManuallyEnded,
'initialUrl'
| 'language'
| 'lastAnswerId'
| 'lastQuestionAsked'
>;

export type MParticleEvent =
  ProductActionEvent
  | PurchaseEvent
  | MPEvent<
  MParticleEventName.SiteSearch,
  'position'
  | 'suggestionType'
  | 'suggestionId'
  | 'suggestionQuery'
  | 'suggestionCount'
  | 'interactionType'
  | 'targetUrl'
  >
  | MPEvent<MParticleEventName.ClickedOfferButton, 'listingId' | 'position' | 'componentName'>
  | MPEvent<MParticleEventName.SubmittedOffer, 'listingId' | 'discountPercent'>
  | MPEvent<MParticleEventName.ViewedSignupSignin, 'source' | 'view'>
  | MPEvent<MParticleEventName.AddedFollow, 'source' | 'followId' | 'followType'>
  | MPEvent<MParticleEventName.RemovedFollow, 'followId'>
  | MPEvent<MParticleEventName.ViewedSimilarCspsRow, 'componentName' | 'listingState'>
  | MPEvent<MParticleEventName.ViewedI2CombinedShipping, 'listingId' | 'combinedRateFree'>
  | MparticleClickedCSPCardEvent
  | MparticleClickedAddToCartEvent
  | MparticleAddToWishlistEvent
  | MparticleRemoveFromWishlistEvent
  | MparticleRemoveFromCartEvent
  | MparticleListingImpressionEvent
  | ClickedListingCardEvent
  | ClickedRecommendedShopCardEvent
  | ViewedCSPComponentEvent
  | ComponentView
  | ViewedFeaturedListing
  | ProductViewActionEvent
  | GenericPageViewEvent
  | ClickedCombineAndSaveViewAll
  | ClickedSellYoursOnCsp
  | AdClick
  | AdImpression
  | MPEvent<MParticleEventName.ApplePayOffered, 'applePayAvailableForDevice'>
  | ClickedShopPoliciesModalEvent
  | SelectedPayoutMethod
  | PlaidLinkEvent
  | ViewedPaymentSettings
  | ClickedLinkList
  | ClickedCategory
  | ClickedTrait;

/**
 * Defined by mParticle: https://github.com/mParticle/mparticle-web-sdk/blob/master-v2/src/types.js#L206-L215
 */
export enum ProductActionType {
  AddToCart = 1,
  RemoveFromCart = 2,
  Checkout = 3,
  CheckoutOption = 4,
  Click = 5,
  ViewDetail = 6,
  Purchase = 7,
  Refund = 8,
  AddToWishlist = 9, // Amplitude: 'Added to Watch List'
  RemoveFromWishlist = 10, // Amplitude: 'Removed from Watch List'
}

/**
 * Defined by mParticle
 */
export enum EventType {
  Navigation = 1,
  Location = 2,
  Search = 3,
  Transaction = 4,
  UserContent = 5,
  UserPreference = 6,
  Social = 7,
  Other = 8,
}
